<div [formGroup]="group" [id] = "'view-selector-wrapper-' + getId()">
  <app-formelementinputlabel [config]="config" [group]="group"></app-formelementinputlabel>
  <app-formelementinputdescription [config]="config" [group]="group"></app-formelementinputdescription>
  <app-formelementinput-validationmessages [config]="config" [group]="group"></app-formelementinput-validationmessages>
  <!--Usamos un fieldset para poder habilitar/deshabiltiar el listado-->
  <fieldset [disabled]="!config.editable">
    <app-viewsselector [formControlName]="config?.name" [config]="config" [group]="group" #formInput>
    </app-viewsselector>
  </fieldset>
</div>
